import { render } from "./pedidos-list-nova.vue?vue&type=template&id=7ee1fafe"
import script from "./pedidos-list-nova.vue?vue&type=script&lang=js"
export * from "./pedidos-list-nova.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__